module.exports = __webpack_public_path__ + "img/Snf.6b9ad25c.png";